<template>
  <div class="shopList">
    <ul class="shop-list" v-for="shop in shopList" :key="shop.shopIds">
      <li class="flex bg-white radius5 mar10-t">
        <div class="shop-img flex-shrink">
          <van-image lazy-load class="radius5-t" :src="`${shop.face}?imageView2/1/w/200/h/260`" />
        </div>
        <div class="pad10 flex flex-auto flex-column justify-between">
          <div class="flex items-center justify-between">
            <div class="flex-auto">
              <p class="black f13 text-overflow">{{ shop.name }}</p>
              <div>
                <van-rate
                  :size="8"
                  v-model="shop.shopLevel"
                  color="#ffc434"
                  void-color="#ddd"
                  readonly
                />
              </div>
            </div>
            <a
              class="flex-shrink f12 white pad10-lr shop-btn radius30"
              :href="`${taaspublicLink}?shopId=${shop.shopIds}`"
              ><span class="white">进店</span></a
            >
          </div>
          <p class="f12 gray9 text-overflow">主营:{{ shop.businessScope }}</p>
          <p class="f12 gray9 text-overflow">地址:{{ shop.addr }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    shopList: Array
  },
  data() {
    return {
      taaspublicLink: process.env.VUE_APP_taaspublic
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {},
  methods: {
    // 点击跳转
    routerClick(url) {
      if (!url) {
        return;
      }
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
